export function teamCoachPoolReducer(state, action) {
  const merge = require('deepmerge');

  switch (action.type) {
    case 'loadCoaches':
      return {
        ...state,
        coaches: action.coaches,
      };
    case 'assignCoachPool':
      return {
        ...state,
        team: action.team,
        coaches: null,
      };
    default:
      throw new Error();
  }
}
